





import AppChipGroup from '@/uikit/components/AppChipGroup/AppChipGroup.vue';

export default {
  name: 'BlogChips',
  components: { AppChipGroup },
  props: {
    chips: {
      type: Array,
      required: true,
    },
    queryName: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      selected: [],
      initialized: false,
    };
  },

  created() {
    if (this.$route.query[this.queryName]) {
      this.selected = new Array(
        ...(Array.isArray(this.$route.query[this.queryName])
          ? this.$route.query[this.queryName]
          : [this.$route.query[this.queryName]] || [])
      );
    }
    this.initialized = true;
  },

  watch: {
    selected: {
      handler(value) {
        if (!this.initialized) return;
        this.routerPushBySelected(value);
      },
      deep: true,
    },
  },

  methods: {
    routerPushBySelected(value) {
      this.$router.replace({
        ...this.$route,
        query: {
          ...this.$route.query,
          page: 1,
          [this.queryName]: Array.isArray(value) ? value : [value] || undefined,
        },
      });
    },
  },
};



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/blog/list/components/BlogChips.vue